import type { JSX } from 'react';
import { BoutonEtiquettes } from '../ImpressionEtiquettes.js';

export function EntreeEtiquettesLot({ oeuvreIds }: { oeuvreIds: readonly string[] }): JSX.Element {
  return <BoutonEtiquettes oeuvreIds={[...oeuvreIds]} />;
}
